// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1UIXw","buttons":"RemoveExpirationActionButtons_buttons__3OKpv"};